import { CircularProgress, MenuItem, TextField } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import Api from "../../utils/services/Api";
import { useSnackbar } from "notistack";

const SelectWithServerData = ({
  value,
  endpoint,
  readOnly,
  mapper = (option) => ({
    value: option.codigo,
    label: option.descripcion,
    cuenta: option.codigoCuenta,
  }),
  ...rest
}) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    ; (async () => {
      if (endpoint) {
        setLoading(true)
        try {
          const response = await Api(endpoint, "GET", null)
          if (mapper) {
            setData(response.map(mapper));
          } else {
            setData(response);
          }
        } catch (error) {
          enqueueSnackbar(error.message, { variant: "error" })
        } finally {
          setLoading(false)
        }
      }
    })()
  }, [endpoint, enqueueSnackbar])

  return (
    <TextField
      fullWidth
      variant="outlined"
      value={value}
      select
      InputProps={{
        endAdornment: loading && (
          <Box display="block">
            <CircularProgress color="inherit" size={20} />
          </Box>
        ),
        readOnly
      }}
      SelectProps={{
        IconComponent: loading ? () => null : undefined
      }}
      disabled={!Boolean(endpoint)}
      {...rest}
    >
      {data.map(option => (
        <MenuItem
          key={option.value}
          value={option.value}
        >
          {option.cuenta?option.cuenta + ' (' + option.label + ')':option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default SelectWithServerData;
